import { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import WasteMetadataFields from "./WasteMetadataFields";

const PhotoCaptureMetadataPage = ({
  initialClient,
  initialWasteCategory,
  initialReference,
  initialWeight,
  initialComment,
  onBack,
  previewImageUrl,
  clientOptions,
  wasteCategoryOptions,
  disabled = false,
  onActiveFieldSheetChange,
}) => {
  const { t } = useTranslation();
  const [draftClient, setDraftClient] = useState(initialClient);
  const [draftWasteCategory, setDraftWasteCategory] =
    useState(initialWasteCategory);
  const [draftReference, setDraftReference] = useState(initialReference);
  const [draftWeight, setDraftWeight] = useState(initialWeight);
  const [draftComment, setDraftComment] = useState(initialComment);

  useEffect(() => {
    setDraftClient(initialClient);
    setDraftWasteCategory(initialWasteCategory);
    setDraftReference(initialReference);
    setDraftWeight(initialWeight);
    setDraftComment(initialComment);
  }, [
    initialClient,
    initialComment,
    initialReference,
    initialWasteCategory,
    initialWeight,
  ]);

  const handleBack = () => {
    onBack({
      selectedClient: draftClient,
      selectedWasteCategory: draftWasteCategory,
      identificationReference: draftReference,
      weightTonnes: draftWeight,
      comment: draftComment,
    });
  };

  return (
    <div className="photo-capture-metadata-inline">
      <div className="photo-capture-metadata-page-shell">
        <h1 className="photo-capture-metadata-page-title">
          {t("mobile_photo_metadata_sheet_title")}
        </h1>

        {previewImageUrl && (
          <div className="photo-capture-metadata-preview">
            <img
              src={previewImageUrl}
              alt={t("mobile_photo_preview_alt")}
              className="photo-capture-metadata-preview-img"
            />
          </div>
        )}

        <WasteMetadataFields
          selectedClient={draftClient}
          onClientChange={setDraftClient}
          selectedWasteCategory={draftWasteCategory}
          onWasteCategoryChange={setDraftWasteCategory}
          identificationReference={draftReference}
          onIdentificationReferenceChange={setDraftReference}
          weightTonnes={draftWeight}
          onWeightChange={setDraftWeight}
          commentText={draftComment}
          onCommentChange={setDraftComment}
          clientOptions={clientOptions}
          wasteCategoryOptions={wasteCategoryOptions}
          disabled={disabled}
          onActiveFieldSheetChange={onActiveFieldSheetChange}
        />

        <div className="installation-settings-card photo-capture-metadata-back-card">
          <button
            type="button"
            className="installation-settings-cell"
            onClick={handleBack}
            disabled={disabled}
          >
            <span
              className="installation-settings-cell-icon installation-settings-cell-icon-default"
              aria-hidden
            >
              <FaChevronLeft />
            </span>
            <span className="installation-settings-cell-body">
              <span className="installation-settings-cell-title">
                {t("mobile_photo_metadata_back_to_photo")}
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoCaptureMetadataPage;
